import React from 'react'
import { Link } from 'react-router-dom'

const TypeCard = ({image,name ,id}:{image:string,name:string,id:string}) => {
  const params = new URLSearchParams();
         params.append("subCategoryId", id);
  return (
    <div className=' p-2 bg-grayColor rounded-lg'>
          <Link to={`/stay-search-result?${params.toString()}`} >
        <div className=' aspect-[4/3] w-full overflow-hidden rounded-lg'>
            <img className='w-full h-full object-cover' src={image} alt="type-image"  loading='lazy'/>
        </div>
        <p className=''>{name}</p>
    </Link>
    </div>

  )
}

export default TypeCard